import angular from 'angular'
import creatDeclaration from './creatDeclaration'
import searchDeclaration from './searchDeclaration'

export default angular
  .module('declaration.addValTaxDeclaration', [
    creatDeclaration,
    searchDeclaration,
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('declaration.addValTaxDeclaration', {
        abstract: true,
        url: '/addValTaxDeclaration',
        template: '<div ui-view></div>',
        title: '增值税报表',
      })
    },
  ]).name



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/index.js